'use client';

import { SearchLogParams } from '~/apis/log';
import { useSendLog } from './useSendLog';
import { omitBy } from 'lodash-es';

export const useSearchLog = () => {
  const sendLog = useSendLog();
  const sendSearchLog = (params: SearchLogParams) => {
    if (!params) return;
    const searchParams = omitBy(params, (value) => value === undefined || value === '');
    sendLog(searchParams);
  };

  return { sendSearchLog };
};
